<template>
  <label class="toggle-label" >
    <input
      type="checkbox"
      class="visually-hidden"
      :checked="modelValue"
      @change="onChange"
      role="switch"
      :aria-checked="modelValue"
      :id="id"
    />
    <div class="toggle-track" :class="{ active: modelValue }">
      <div class="toggle-thumb"></div>
    </div>
  </label>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: '',
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

function onChange(event) {
  const value = event.target.checked
  emit('update:modelValue', value)
  emit('change', value)
}
</script>

<style scoped>
.toggle-label {
  cursor: pointer;
  display: inline-block;
  user-select: none;
}

.visually-hidden {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.toggle-track {
  width: 48px;
  height: 24px;
  background-color: #ccc;
  border-radius: 24px;
  position: relative;
  transition: background-color 0.3s;
}

.toggle-track.active {
  background-color: #082A9D;
}

.toggle-thumb {
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.3s;
}

.toggle-track.active .toggle-thumb {
  transform: translateX(24px);
}

.dark .toggle-track {
  background-color: #444;
}
.dark .toggle-track.active {
  background-color: #0A4BFF;
}
.dark .toggle-thumb {
  background-color: #fff;
}
</style>
